<template>
  <div v-if="data">
    <h3>¿Desea cancelar el cobro #{{ data.DocNum }}?</h3>
    <hr class="my-3" />
    <div v-if="data.U_TS_ReportID" class="mb-4">
      <p class="text-sm font-weight-bold mb-1">
        Motivo de Cancelación *
      </p>
      <multiselect
        v-model="cancelForm.reason"
        :options="cancelReasons"
        label="name"
        placeholder="Seleccionar Motivo de Cancelación"
        :show-labels="false"
        :allow-empty="false"
      />
    </div>
    <div>
      <p class="text-sm font-weight-bold mb-1">
        Fecha de Cancelación *
      </p>
      <base-radio
        v-if="isDocDateInCurrentMonth 
          || [
            'dannasandoval@canplast.com.mx',
            'ofelialujan@canplast.com.mx',
            'lizethflores@canplast.com.mx'
          ].includes(user.email)"
        v-model="cancelForm.date"
        name="original_doc"
        value="original_doc"
      >
        Fecha del documento original
      </base-radio>
      <base-radio
        v-model="cancelForm.date"
        name="system_date"
        value="system_date"
      >
        Fecha del sistema actual
      </base-radio>
    </div>
    <hr class="my-4" />
    <div class="d-flex justify-content-end">
      <base-button @click="$emit('close')" type="secondary">No</base-button>
      <base-button
        @click="cancelIP()"
        type="danger"
        :disabled="
          canceling ||
          (data.U_TS_ReportID && !cancelForm.reason) ||
          !cancelForm.date
        "
      >
        Si, cancelar
      </base-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import { getAuth } from "firebase/auth";

export default {
  name: "CancelIncPayment",
  components: {
    Multiselect,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      canceling: false,
      cancelForm: {
        reason: null,
        date: null,
      },
      cancelReasons: [
        { id: "02", name: "02 - Comprobante emitido con errores sin relación" },
      ],
      user: null,
    };
  },
  computed: {
    isDocDateInCurrentMonth() {
      if (!this.data || !this.data.DocDate) return false;
      
      const docDate = new Date(this.data.DocDate);
      const currentDate = new Date();
      
      return docDate.getFullYear() === currentDate.getFullYear() &&
             docDate.getMonth() === currentDate.getMonth();
    },
  },
  created(){
    const auth = getAuth();
    this.user = auth.currentUser;
    if(this.data.U_TS_ReportID){
      this.cancelForm.reason = this.cancelReasons[0];
    }
    // Si la fecha del documento está en el mes actual, usar fecha original, sino usar fecha del sistema
    this.cancelForm.date = this.isDocDateInCurrentMonth ? "original_doc" : "system_date";
  },
  methods: {
    cancelIP() {
      const docEntry = this.data.DocEntry;
      if (!this.canceling) {
        this.canceling = true;

        const json = {
          DocEntry: docEntry,
          type: this.data.U_WebXML ? "credito" : "contado",
          fpt: null,
          option: this.cancelForm.date,
        };
        axios
          .get(`/api/customers/${this.data.CardCode}`)
          .then((res) => {
            if (this.data.U_WebXML) {
              json.fpt = {
                uuid: this.data.U_TS_ReportID,
                rfc: res.data.FederalTaxID,
                reason: this.cancelForm.reason.id,
                monto: 0,
              };
            }
            console.log("JSON CANCEL", json);
            axios
              .post(`api/fpt/v2/pagos/cancel`, json)
              .then((res) => {
                console.log("CANCEL RESPONSE", res.data);
                if (
                  (this.data.U_WebXML && res.data.msg && res.data.acuse) || // Crédito
                  (!this.data.U_WebXML && res.data.msg && res.data.msg) // Contado
                ) {
                  if (res.data.msg && !res.data.msg.toLowerCase().includes("error")) {
                    this
                      .$swal(`Cobro #${this.data.DocNum} cancelado`, res.data.msg, "success")
                      .then(() => {
                        this.$emit("close");
                      });
                    this.$emit("success");
                  } else if (res.data.msg) {
                    this.$swal("Error", res.data.msg, "error");
                  } else {
                    this.$swal(
                      "Error",
                      "Ocurrió un error al cancelar el cobro",
                      "error"
                    );
                    console.error(res.data);
                  }
                } else if (res.data.msg) {
                  this.$swal("Error", res.data.msg, "error");
                } else {
                  this.$swal(
                    "Error",
                    "Ocurrió un error al cancelar el cobro",
                    "error"
                  );
                  console.error(res.data);
                }
              })
              .catch((err) => {
                this.$swal(
                  "Error",
                  "Ocurrió un error al cancelar el cobro",
                  "error"
                );
                console.error(err);
              })
              .finally(() => {
                this.canceling = false;
              });
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
